import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
export function template() {
  const { iconSize } = this.helpers.getIconProperties();
  return /* @__PURE__ */ jsx("div", {
    sel: ".container"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: {
      elref: `orgImg`,
      align: `middle`,
      icon: `mixpanel-logo`
    },
    style: {
      height: `${iconSize}px`,
      width: `${iconSize}px`,
      color: `white`
    }
  }), this.helpers.isTooltipEnabled() ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: this.attr(`tooltip-placement`) }
  }, this.attr(`tooltip-text`)) : null);
}
